import tw from 'tailwind-styled-components';
import styled from 'styled-components';
import { Title, Text as Paragraph } from '../Typography';

export const Container = tw.div`
  relative
`;

export const IntroContent = tw.div`
  text-center
`;

export const SubHeading = tw(Paragraph)`
  mb-2.5
`;

export const Heading = tw(Title)`
  mb-5
`;

export const Description = tw(Paragraph)`
  mx-auto
`;

export const TextContainer = styled.div<{ backgroundMobile: string; backgroundDesktop: string }>`
  background-image: url(${({ backgroundMobile }) => backgroundMobile});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
  padding-top: 90px;
  padding-bottom: 112px;

  @media (min-width: 768px) {
    padding-top: 128px;
    background-image: url(${({ backgroundDesktop }) => backgroundDesktop});
  }

  @media (min-width: 1439px) {
    padding-top: 166px;
  }
`;

export const CardsContainer = styled.div`
  margin-top: -90px;
  @media (min-width: 1439px) {
    padding-top: -166px;
  }
`;

export const CarouselCard = styled.div`
  margin-right: 5px;
  min-width: 88%;
  @media (min-width: 768px) {
    min-width: 92%;
  }
`;
CarouselCard.displayName = 'CarouselCard';
